import React from 'react';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { HuchaRenovadoresCard } from './hucha-renovadores-card/hucha-renovadores-card';
import { HuchaStandardCard } from './hucha-standard-card/hucha-standard-card';

export const HuchaVentaCard = ({ huchaValues }: { huchaValues: HuchaVentaValues }): React.ReactElement => {
	if (huchaValues?.huchaTier !== 'standard') {
		return <HuchaRenovadoresCard huchaValues={huchaValues} />;
	}
	return <HuchaStandardCard huchaValues={huchaValues} />;
};
